'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconPause, iconPauseTag } from '@ni/nimble-components/dist/esm/icons/pause';
import { wrap } from '../../utilities/react-wrapper';

export type { IconPause };
export { iconPauseTag };
export const NimbleIconPause = wrap(IconPause);